import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import NumberItem from '../../topbar/telephony/components/items/NumberItem';
export default class SimpleListNumbers extends Component {
    constructor(props) {
        super(props);
        this.changeFromNumber = (fromNumber) => {
            this.props.changeFromNumber(fromNumber);
        };
    }
    render() {
        const listNumber = (number, index) => {
            let className = 'disabled';
            let disabled = true;
            if (number.incoming_functionality === true ||
                number.incoming_verified === true) {
                disabled = false;
                className = '';
            }
            if (number.outgoing_functionality) {
                disabled = false;
                className = '';
                if (this.props.dynamicTelephoneNumbersArray &&
                    this.props.dynamicTelephoneNumbersArray.length === 1) {
                    className += ' active';
                }
            }
            if (this.props.selectedFromNumber &&
                this.props.selectedFromNumber === number.e164_format) {
                className += ' active';
            }
            if (this.props.selectingDefault &&
                number.outgoing_functionality === false) {
                disabled = true;
                className = 'disabled';
            }
            return (_jsx(NumberItem, { index: index, disabled: disabled, className: className, changeFromNumber: this.changeFromNumber, number: number }, index));
        };
        return (_jsx("div", { children: this.props.dynamicTelephoneNumbersArray &&
                this.props.dynamicTelephoneNumbersArray.map(listNumber) }));
    }
}
